import script from "./CommunitiesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunitiesList.vue?vue&type=script&lang=ts&setup=true"

import "./CommunitiesList.vue?vue&type=style&index=0&id=c6704d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6704d60"]])

export default __exports__